import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import Klanten360Profile from './Klanten360Profile';
import './Klanten360Modal.css';
import '../../pages/Klanten360.css';

export default function Klanten360Modal({
  open,
  email,
  profile,
  loading,
  error,
  onClose,
  onUnlinkVisitor,
  unlinkBusyId,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="klanten360-modal-root" role="presentation" onClick={onClose}>
      <div
        className="klanten360-modal-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="klanten360-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="klanten360-modal-head">
          <div>
            <p className="klanten360-modal-kicker">Klant 360°</p>
            <h2 id="klanten360-modal-title">{email || 'Profiel'}</h2>
          </div>
          <button type="button" className="klanten360-modal-close" onClick={onClose} aria-label="Sluiten">
            <FiX />
          </button>
        </header>
        <div className="klanten360-modal-body">
          {loading ? <p className="muted">Profiel laden…</p> : null}
          {error ? <p className="marketing-ig-error">{error}</p> : null}
          {!loading && profile ? (
            <Klanten360Profile
              profile={profile}
              onUnlinkVisitor={onUnlinkVisitor}
              unlinkBusyId={unlinkBusyId}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
